module.exports = __webpack_public_path__ + "5e67a6fef3ee9dc73e19c65e93a2fd39.svg";